import React from 'react';

import classNames from 'classnames';
import Image from 'next/image';

import { Link, Pill } from '../../elements';
import { getReadTime } from '../helpers';
import '../styles/popover.module.scss';
import BlogCardStyles from './BlogCard.module.scss';
import { IBlogCard } from './BlogCard.types';
import SocialsPopover from './SocialsPopover';

const BlogCard = ({
  data: { img, category, title, tags, description, button, body },
  variant,
}: IBlogCard) => {
  return (
    <article
      className={classNames(BlogCardStyles.blogCardWrapper, {
        [BlogCardStyles[`blogCardWrapper_${variant}`]]: variant,
      })}
    >
      <div className={BlogCardStyles.visualWrapper}>
        <Link to={button.path} title={button.title}>
          <Image
            loading="lazy"
            className={BlogCardStyles.visual}
            src={img.path}
            alt={img.alt}
            width={508}
            height={254}
          />
        </Link>
      </div>

      <div className={BlogCardStyles.content}>
        <div className={BlogCardStyles.mainInfo}>
          <span className={BlogCardStyles.eventType}>{category}</span>
          <h3 className={BlogCardStyles.title}>
            <Link to={button.path} title={button.title}>
              {title}
            </Link>
          </h3>
          <p className={BlogCardStyles.summary}>{description}</p>
        </div>
        <div className={BlogCardStyles.controlsWrapper}>
          <div className={BlogCardStyles.controls}>
            <Link className={BlogCardStyles.readMore} to={button.path} title={button.title}>
              {button.label}
            </Link>
            <span className={BlogCardStyles.readTime}>{getReadTime(body)}</span>
            <SocialsPopover title={title} url={button.path} />
          </div>
          {!!tags.length && (
            <div className={BlogCardStyles.tags}>
              {tags.map((item) => (
                <Pill label={item} key={item} />
              ))}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
